import React from 'react';
import { motion } from 'framer-motion';

// Static premium lineup — the complete Tropic Blue collection in one frame
const BottleCarousel = () => {
  return (
    <div className="relative flex flex-col items-center">
      <div className="relative w-[320px] sm:w-[440px] lg:w-[540px] xl:w-[580px]">
        {/* Outer decorative frame */}
        <div className="absolute -inset-3 border border-[#c4a24a]/25 pointer-events-none z-20" />
        <div className="absolute -inset-6 border border-[#c4a24a]/12 pointer-events-none z-20" />

        {/* Corner accents */}
        <CornerAccents />

        {/* Lineup stage — soft white so the collection photo blends seamlessly */}
        <div className="relative flex items-center justify-center overflow-hidden">
          <div
            className="absolute inset-0"
            style={{
              background:
                'radial-gradient(ellipse at 50% 30%, #ffffff 0%, #fdfbf6 60%, #f5efdf 100%)',
            }}
          />
          {/* Warm light */}
          <div
            className="absolute inset-0"
            style={{
              background:
                'radial-gradient(ellipse at 50% 15%, rgba(255,240,200,0.35) 0%, transparent 55%)',
            }}
          />

          <motion.img
            src="/bottles/lineup.jpeg"
            alt="The complete Tropic Blue bottle collection"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1.2, delay: 0.3, ease: [0.22, 1, 0.36, 1] }}
            className="relative w-full h-auto object-contain"
            loading="eager"
            data-testid="hero-lineup-image"
          />
        </div>
      </div>

      {/* Tagline below the frame */}
      <motion.div
        initial={{ opacity: 0, y: 15 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.9, ease: [0.22, 1, 0.36, 1] }}
        className="mt-8 text-center max-w-sm"
      >
        <div className="text-[9px] tracking-[0.35em] text-[#c4a24a] uppercase font-medium mb-2">
          The Complete Collection
        </div>
        <div
          className="text-[15px] lg:text-[17px] text-[#0f2c6b] italic font-light leading-snug"
          style={{ fontFamily: 'Fraunces, serif' }}
        >
          &ldquo;One source. Every silhouette.&rdquo;
        </div>
      </motion.div>
    </div>
  );
};

const CornerAccents = () => (
  <>
    <div className="absolute -top-4 -left-4 w-6 h-6 border-t border-l border-[#c4a24a] pointer-events-none z-20" />
    <div className="absolute -top-4 -right-4 w-6 h-6 border-t border-r border-[#c4a24a] pointer-events-none z-20" />
    <div className="absolute -bottom-4 -left-4 w-6 h-6 border-b border-l border-[#c4a24a] pointer-events-none z-20" />
    <div className="absolute -bottom-4 -right-4 w-6 h-6 border-b border-r border-[#c4a24a] pointer-events-none z-20" />
  </>
);

export default BottleCarousel;
